export default __webpack_public_path__ + "static/media/sharjeel baig.822857b8.PNG";